import * as React from 'react'
import { vsprintf } from 'sprintf-js'
import dynamic from 'next/dynamic'

import { i18n, Routes } from '@thg-commerce/enterprise-core'
import { Separator, VisuallyHidden } from '@thg-commerce/gravity-elements'
import {
  NoResultsFoundContainer,
  Subtitle,
  StyledList,
  StyledListItem,
  DiscontinuedText,
  Title,
  HiddenLabel,
  SearchButton,
  SearchContainer,
  SearchForm,
  SearchInput,
} from './styles'

const Search = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/SearchIcon'),
)

export const NoSearchResultsFound = (props: { query: string }) => {
  const i18nText = {
    title: i18n('content.searchresults.noresultsfound.title'),
    subtitle: i18n('content.searchresults.noresultsfound.subtitle'),
    searchTips: {
      tip1: i18n('content.searchresults.noresultsfound.searchtips.1'),
      tip2: i18n('content.searchresults.noresultsfound.searchtips.2'),
      tip3: i18n('content.searchresults.noresultsfound.searchtips.3'),
    },
    discontinuedText: i18n(
      'content.searchresults.noresultsfound.discontinuedtext',
    ),
    search: {
      formTitle: i18n('content.searchresults.noresultsfound.searchform.title'),
      formPlaceholder: i18n(
        'content.searchresults.noresultsfound.searchform.placeholder',
      ),
      buttonTitle: i18n(
        'content.searchresults.noresultsfound.searchform.button.title',
      ),
    },
  }
  const inputRef = React.createRef<HTMLInputElement>()

  const { v4: uuid } = require('uuid')
  const searchUuid = uuid()

  const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    if (inputRef.current && inputRef.current.value.length < 1) {
      e.preventDefault()
    }
    return
  }

  return (
    <NoResultsFoundContainer>
      <Title data-testid="no-search-results-found-title">
        {vsprintf(i18nText.title, [props.query])}
      </Title>
      <Separator />
      <Subtitle>{i18nText.subtitle}</Subtitle>
      <StyledList>
        <StyledListItem>{i18nText.searchTips.tip1}</StyledListItem>
        <StyledListItem>{i18nText.searchTips.tip2}</StyledListItem>
        <StyledListItem>{i18nText.searchTips.tip3}</StyledListItem>
      </StyledList>
      <DiscontinuedText>{i18nText.discontinuedText}</DiscontinuedText>
      <Separator />
      <SearchContainer>
        <SearchForm
          action={Routes.Search}
          method="GET"
          onSubmit={handleSearchSubmit}
        >
          <HiddenLabel htmlFor={`search-${searchUuid}`}>
            {i18nText.search.formPlaceholder}
          </HiddenLabel>
          <SearchInput
            placeholder={i18nText.search.formPlaceholder}
            title={i18nText.search.formTitle}
            ref={inputRef}
            id={`search-${searchUuid}`}
            type="text"
            name="search"
          />
          <SearchButton title={i18nText.search.buttonTitle} type="submit">
            <VisuallyHidden text={i18nText.search.buttonTitle} />
            <Search />
          </SearchButton>
        </SearchForm>
      </SearchContainer>
    </NoResultsFoundContainer>
  )
}
